// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JRgc","content":"styles_content__T2_Ve"};